import { render } from "./Header.vue?vue&type=template&id=ac812628&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=ac812628&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/aldasforras_vue/aldasforras_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac812628"]])

export default __exports__